import React from "react";
import phoneImg from "../../assets/multiflatform-img-2.png";
import GlowButton from "./GlowButton";
import DatapointBadges from "./DatapointBadges";

const MultiFlatformScroll = () => {
  return (
    <section
      className="
        flex flex-col md:flex-row justify-between items-center
        w-full px-4 sm:px-6 md:px-12 lg:px-12
        py-20 md:py-16
        text-white min-h-screen mt-24 sm:mt-0 md:mt-2 pb-[12rem] lg-xl:mt-[90px] xl-2xl:mt-16
        overflow-x-hidden
      "
    >
      {/* LEFT SECTION */}
      <div className="flex justify-center items-center w-full md:w-1/2 mt-0 lg-xl:mt-[-10rem] md:mt-0 md:mr-[-1rem] lg-xl:mr-[-1rem] xl-2xl:mr-[-5.3rem]">
        <div
          className="
            grid
            max-w-[650px]
            w-[240px] sm:w-[350px] md:w-[340px] lg-xl:w-[440px] xl-2xl:w-[550px]
            h-[250px] sm:h-[360px] md:h-[380px] lg-xl:h-[480px] xl-2xl:h-[600px]
            p-0
            rounded-2xl overflow-hidden
          "
        >
          <div className="w-full h-full rounded-xl overflow-hidden">
            <img
              src={phoneImg}
              alt="multi-platform app preview"
              className="w-full h-full object-contain rounded-xl"
            />
          </div>
        </div>
      </div>

      {/* RIGHT SECTION */}
      <div className="max-w-3xl text-center md:text-left space-y-5 w-full md:w-1/2 mt-6 sm:mt-8 md:mt-0 lg-xl:pb-[200px] xl-2xl:pb-[50px]">
        <h1 className="text-3xl sm:text-3xl md:text-5xl lg:text-[70px] font-lexend font-bold leading-tight">
          <span className="text-[#FCBA05]">multi-platform</span>, on mobile and web, download now!
        </h1>
        <p className="text-[#FCBA05] font-lexend font-bold text-2xl sm:text-3xl md:text-4xl lg:text-[48px] leading-tight">
          serve more, spend less!
        </p>

        <p className="text-gray-200 leading-relaxed text-sm sm:text-base md:text-lg lg:text-xl font-poppins mt-6 max-w-lg md:max-w-xl mx-auto md:mx-0">
          with beɘmz digital services – menus, catalogs, customer orders and inquiries, in-app
          transactions and advertising, you will save up to 300% compared to others
        </p>

        <ul className="space-y-2 text-gray-100 text-sm sm:text-base md:text-lg font-poppins">
          {[
            "no commissions. no hidden charges. just fair, fixed pricing that keeps your revenue yours.",
            "beɘmz isn't just affordable, it's unbeatable.",
          ].map((text, i) => (
            <li key={i} className="flex items-start gap-3 justify-center md:justify-start">
              <svg className="w-5 h-5 shrink-0 mt-1" viewBox="0 0 512 512" fill="none">
                <circle cx="256" cy="256" r="256" fill="rgba(255,255,255,0.25)" />
                <polyline points="160,256 230,320 352,192" fill="none" stroke="white" strokeWidth="32" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span className="text-left leading-relaxed">{text}</span>
            </li>
          ))}
        </ul>

        {/* Datapoints badges */}
        <DatapointBadges keys={["increase_revenue", "reduce_cost"]} className="justify-center md:justify-start"
        />

        {/* CTA Buttons */}
        <div className="flex flex-wrap justify-center md:justify-start gap-4 mt-[10px] sm:mt-[20px] xl-2xl:mt-[30px]">
          <button
            onClick={() => window.location.href = "/business/demo"}
            className="inline-flex items-center justify-center whitespace-nowrap border border-[#6E3FC6] bg-[#e9d9ff] hover:bg-[#d8bfff] text-black text-sm sm:text-base font-medium px-[18px] sm:px-[25px] lg:px-[40px] rounded-full transition-all duration-300 cursor-pointer"
          >
            how it works
          </button>
          <GlowButton btnValue="free trial" btn1="2" onClick={() => window.location.href = "/business/get-started"} />
        </div>
      </div>
    </section>
  );
};

export default MultiFlatformScroll;
